<!--
 * @Description: 数字拜访 17
 * @Date: 2022-06-27 10:50:51
-->
<template>
  <div class="academy-edit-box">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="230px"
      class="ruleForm"
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div class="left">
          <div>
            <xrk-subtitle>项目信息</xrk-subtitle>
            <el-form-item label="项目编码：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
              <el-button
                type="primary"
                class="copyBtn_1"
                :data-clipboard-text="ruleForm.projectNo"
                @click="$copy('copyBtn_1')"
              >
                复制
              </el-button>
            </el-form-item>
            <el-form-item
              label="客户企业："
              prop="enterpriseId"
              v-if="hasIndustry || penetratingDisplay != -1"
            >
              <el-tooltip
                effect="dark"
                :content="ruleForm.industryEnterpriseName"
                placement="top"
              >
                <el-input
                  disabled
                  :value="ruleForm.industryEnterpriseName"
                  v-if="hasIndustry || penetratingDisplay != -1"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectName">
              <el-input disabled v-model.trim="ruleForm.projectName"></el-input>
            </el-form-item>
            <el-form-item
              label="项目简介："
              prop="introduction"
              class="absoluteBox"
            >
              <el-input
                :class="{
                  redText:
                    !(ruleForm.industryEnterpriseId > 0) &&
                    !addEditMixin_introductionDisbaled
                }"
                type="textarea"
                v-model.trim="ruleForm.introduction"
                placeholder="请输入项目简介"
                :rows="7"
                maxlength="200"
                :show-word-limit="true"
                :disabled="addEditMixin_introductionDisbaled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="项目结算单价（不含税）："
              v-if="hasIndustry"
              prop="price"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.price"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item label="终端结算单价：" prop="csoPrice">
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.csoPrice"
                :maxlength="11"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item
              label="税率："
              v-if="hasIndustry"
              prop="contractScale"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.contractScale"
              ></el-input>
              <span style="margin-left:10px;">%</span>
              <!-- {{ ruleForm.contractScale | transScale }} -->
            </el-form-item>
            <el-form-item label="总任务量：" prop="taskSumCount">
              <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
            </el-form-item>
            <el-form-item label="已完成任务量：">
              <el-input
                disabled
                :value="ruleForm.finishSumCount || 0"
              ></el-input>
            </el-form-item>
            <!-- 项目支付通道 -->
            <pay-channel />
          </div>

          <div style="margin-top:50px">
            <xrk-subtitle>项目执行要求</xrk-subtitle>
            <el-form-item label="背景需求：" prop="projectBackground">
              <el-select
                v-model="ruleForm.projectBackground"
                :disabled="addEditMixin_disbaled"
                placeholder="请选择背景"
                @change="addEditMixin_validateBackground"
              >
                <el-option
                  v-for="item in addEditMixin_backgroundList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="审核人员对其可见：">
              <reviewer
                :disabled="addEditMixin_disbaled"
                :info="ruleForm"
              ></reviewer>
            </el-form-item>
            <!--1 项目执行人脱敏规则：-->
            <tm-execute-name-rule
              v-model="ruleForm.tmExecuteNameRule"
              :disabled="addEditMixin_disbaled"
            />

            <!--2 目标姓名脱敏规则：-->
            <tm-target-name-rule
              v-model="ruleForm.tmTargetNameRule"
              :ruleForm="ruleForm"
              :disabled="addEditMixin_disbaled"
            />

            <el-form-item
              v-for="(ele, i) in addEditMixin_formItems"
              :label="ele.label"
              :key="i"
              :prop="ele.prop"
              :rules="ele.rule"
            >
              <el-input
                v-model="ruleForm[ele.prop]"
                :disabled="addEditMixin_disbaled"
                v-bind="ele"
              >
                <template #append>
                  {{ ele.suffix }}
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" v-html="ele.content"></div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="职业认证：" prop="isOccupationAuth">
              <el-radio-group
                v-model="ruleForm.isOccupationAuth"
                :disabled="addEditMixin_disbaled"
              >
                <el-radio
                  border
                  class="auth-type"
                  :label="item.type"
                  v-for="(item, index) in isOccupationAuthArray"
                  :key="`way${index}`"
                >
                  {{ item.value }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="ruleForm.isOccupationAuth">
              <el-form-item label="认证类型：" prop="occupationType">
                <!-- <span>认证类型：</span> -->
                <span>
                  <el-select
                    v-model="ruleForm.occupationType"
                    :disabled="addEditMixin_disbaled"
                    placeholder="请选择认证类型"
                  >
                    <el-option
                      v-for="item in occupationTypeArray"
                      :key="item.id"
                      :value="item.id"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </span>
              </el-form-item>
              <el-form-item label="认证方式：" prop="occupationAuthMode">
                <el-radio-group
                  v-model="ruleForm.occupationAuthMode"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio
                    border
                    :label="item.type"
                    v-for="(item, index) in occupationAuthModeArray"
                    :key="`way${index}`"
                  >
                    {{ item.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item
              label="订单支付审核："
              v-if="ruleForm.isOrderAudit == 1"
            >
              <el-button
                plain
                style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
              >
                需审核
              </el-button>
              <span>
                项目支付给自然人时需进行审核
              </span>
            </el-form-item>
            <el-form-item label="是否需要执行人上传资质证明：">
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="1"
              >
                需要
              </el-radio>
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="0"
              >
                不需要
              </el-radio>
            </el-form-item>
            <updateQualificationProof
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.certificationClassifyList"
              @selectOptionsDataEvent="selectOptionsDataEvent"
              v-if="ruleForm.isNeedCertification === 1"
            ></updateQualificationProof>
          </div>
        </div>

        <div class="right">
          <xrk-subtitle>需求信息</xrk-subtitle>
          <!--todo 添加需求信息-->
          <el-form-item label="封面图：" prop="bgUrl">
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="addEditMixin_disbaled"
            ></GenerateImage>
          </el-form-item>
          <el-form-item label="关联推广专区：" prop="channelId" ref="channelId">
            <el-radio-group
              v-if="ruleForm.industryEnterpriseId > 0"
              v-model="ruleForm.channelEditorType"
              :disabled="addEditMixin_disbaled"
              @change="onChangeChannelEditorType"
            >
              <el-radio :label="1">发起方编辑</el-radio>
              <el-radio :label="2">服务商编辑</el-radio>
            </el-radio-group>

            <div
              style="margin-top:10px"
              v-show="ruleForm.channelEditorType === 2"
            >
              <dic-select
                @dic-select-obj="addEditMixin_saveChannelId"
                placeholder="推广专区"
                ajaxQuery="title"
                :fuzzyDef="searchAjax"
                :prop="prop"
                :defaultActive="defaultObj"
                :ifClearable="true"
                :isDisabled="
                  ruleForm.channelEditorType != 2 || addEditMixin_disbaled
                "
              />
            </div>
          </el-form-item>

          <el-form-item label="推广链接：">
            <el-input
              style="width:240px"
              disabled
              placeholder="链接"
              :value="addEditMixin_channelWebUrl"
            ></el-input>
            <el-button
              :disabled="!Boolean(addEditMixin_channelWebUrl)"
              type="success"
              class="copyBtn"
              :data-clipboard-text="addEditMixin_channelWebUrl"
              @click="addEditMixin_copy"
              ref="copyBtn"
            >
              复制链接
            </el-button>
            <div
              v-if="Boolean(addEditMixin_channelWebUrl)"
              style="display: inline-block;margin-left:10px;"
              v-amplifyImg="$getQrcodeUrl(addEditMixin_channelWebUrl)"
              :src="$getQrcodeUrl(addEditMixin_channelWebUrl)"
            >
              <img :src="require('@/assets/img/ewm.svg')" alt />
            </div>
          </el-form-item>
          <el-form-item label="认证方案：" prop="authType">
            <el-radio-group
              v-model="ruleForm.authType"
              :disabled="addEditMixin_disbaled"
            >
              <el-radio
                border
                class="auth-type"
                :label="item.type"
                v-for="(item, index) in occupationMixin_way"
                :key="`way${index}`"
              >
                {{ item.value }}
              </el-radio>
            </el-radio-group>
            <p>
              {{
                occupationMixin_authTypeTips &&
                  occupationMixin_authTypeTips['tip']
              }}
            </p>
          </el-form-item>
          <el-form-item label="拜访目标：" prop="szVisitType">
            <el-select
              v-model="ruleForm.szVisitType"
              :disabled="addEditMixin_disbaled"
            >
              <el-option
                :label="item.value"
                :value="item.type"
                v-for="(item, index) in szVisitTypeList"
                :key="`way${index}`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参与人员反馈：" prop="feedbacks">
            <div v-for="(item, index) in ruleForm.feedbacks" :key="index">
              <el-input
                v-model.trim="ruleForm.feedbacks[index].feedback"
                style="margin-bottom:10px"
                maxlength="100"
                show-word-limit
                :disabled="item.isOther === 1 || addEditMixin_disbaled"
              ></el-input>
              <el-button
                type="text"
                @click="addEditMixin_editTransmitList('feedbacks', index)"
                v-show="item.isOther === 0"
                :disabled="addEditMixin_disbaled"
              >
                删除
              </el-button>
            </div>
            <el-button
              type="text"
              @click="addEditMixin_editTransmitList('feedbacks')"
              :disabled="addEditMixin_disbaled"
            >
              新增
            </el-button>
          </el-form-item>
          <el-form-item
            label="是否需要全部打开才能反馈："
            prop="numberVisitIsAllOpen"
          >
            <el-switch
              v-model="ruleForm.numberVisitIsAllOpen"
              :inactive-value="0"
              :active-value="1"
              active-text="是"
              inactive-text="否"
              :disabled="addEditMixin_disbaled"
            ></el-switch>
          </el-form-item>

          <!-- <common-items :disabled="addEditMixin_disbaled" />-->
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="addEditMixin_disbaled"
          >
            保存
          </el-button>
          <submit-verify-btn
            @finish="addEditMixin_finishSubmit"
            :auditStatus="ruleForm.auditStatus"
            :ifDis="addEditMixin_disbaled"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :info="ruleForm"
          :submitFn="addEditMixin_finishSubmit"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
  </div>
</template>
<script>
import { selectChannel } from '@/api/ajax';

import addEdit from '@/page/project-classify/src/mixins/add-edit';

import { szVisitTypeList } from './targetMap.js';
import updateQualificationProof from '../../../update-qualification-proof/update-qualification-proof';

export default {
  name: 'digital',
  mixins: [addEdit],
  components: { updateQualificationProof },
  data() {
    const checkChannel = (rule, value, callback) => {
      if (this.ruleForm.channelEditorType === 2 && !value) {
        callback(new Error('请选择关联专区'));
      } else {
        callback();
      }
    };
    return {
      occupationMixin_way: [
        {
          type: 0,
          value: '无须认证',
          tip: '该项目将不使用认证方案'
        },
        {
          type: 1,
          value: '客户签名',
          tip: '使用该方案后，终端用户需提交客户的手绘签名'
        }
      ],
      szVisitTypeList,

      searchAjax: selectChannel,
      fileList: [],
      prop: {
        label: 'title',
        code: 'id'
      },
      defaultObj: {
        title: '',
        id: ''
      },
      initChannel: {}, // 用于备份初始专区
      ruleForm: {
        selectOptionsDatas: [],
        transmitList: [''],
        feedbacks: ['积极', '中立', '消极', '其他'],
        approvalNumber: '',
        guige: '',
        jixing: '',

        szVisitType: '',
        dialogVisible: false,

        channelId: '',
        channelEditorType: 1,
        tmExecuteNameRule: '', // 项目执行人脱敏
        tmTargetNameRule: '' // 目标姓名脱敏规则
      },
      // 校验
      rules: {
        // 项目执行人脱敏
        tmExecuteNameRule: [
          {
            required: true,
            message: '请选择脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        // 目标姓名脱敏规则
        tmTargetNameRule: [
          {
            required: true,
            message: '请选择目标姓名脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择目标姓名脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        numberVisitIsAllOpen: [
          {
            required: true,
            message: '请选择是否需要全部打开才能反馈',
            trigger: 'blur'
          }
        ],

        szVisitType: [
          {
            required: true,
            message: '请选择拜访目标',
            trigger: 'blur'
          }
        ],

        channelId: [
          {
            required: true,
            trigger: 'blur',
            validator: checkChannel
          }
        ]
      }
    };
  },

  watch: {
    'ruleForm.selectOptionsDatas': {
      deep: true,
      handler(newObj, oldObj) {
        console.log('v-model', newObj);
      }
    },
    //如果拜访目标为患者则姓名脱敏规则强制为字母缩写并禁用
    'ruleForm.szVisitType': {
      handler(v) {
        this.ruleForm.tmTargetNameRule = 1;
        if (+v === 13) {
          this.ruleForm.tmTargetNameRule = 4;
        }
      }
    }
  },
  methods: {
    onChangeChannelEditorType(v) {
      if (v === 1) {
        this.ruleForm.channelId = '';
        this.addEditMixin_setChannelUrl();
      }
      if (v === 2) {
        this.addEditMixin_saveChannelId(this.initChannel);
      }
      this.$refs.channelId.$emit('el.form.blur');
    }
  },
  async created() {
    const data = await this.addEditMixin_init();

    let { tXcxProject, tCrmProduct, feedbackList, channelName, channel } = data;
    channel = channel || { title: '', id: '' };

    tCrmProduct.productId = tCrmProduct.id;
    delete tCrmProduct.id;

    let obj = Object.assign({}, tCrmProduct, tXcxProject, {
      channelName: channelName,
      feedbacks: feedbackList,
      channelId: channel.id
    });

    this.defaultObj = {
      title: channel.title,
      id: channel.id
    };
    this.ruleForm = {
      ...this.ruleForm,
      ...obj
    };
    this.ruleForm.isNeedCertification = this.homeProject.isNeedCertification;
    this.ruleForm.certificationClassifyList = this.homeProject.certificationClassifyList;
    this.ruleForm.channelEditorType = this.ruleForm.channelEditorType || 2; // 默认为服务商编辑
    this.initChannel = channel;
    this.addEditMixin_setChannelUrl(channel.id);
    this.$nextTick(() => {
      this.$refs.copyBtn.$el.disabled = !this.addEditMixin_channelWebUrl;
      this.$refs.copyBtn.$el.className = 'el-button copyBtn el-button--success';
    });

    const noCache = {
      tmTargetNameRule: obj.tmTargetNameRule
    };
    setTimeout(() => {
      this.ruleForm = {
        ...this.ruleForm,
        ...noCache
      };
    });
    this.$emit('resetRuleForm', this.ruleForm);
  }
};
</script>
<style lang="scss">
.academy-edit-box {
  .ruleForm .el-form-item .el-input,
  .ruleForm .el-form-item .el-textarea {
    width: 350px;
  }
}
</style>
<style lang="scss" scoped>
>>> .el-radio-group {
  display: flex;
  align-items: center;
}
.title {
  font-size: 16px;
  margin: 1em 0 1em 20px;
  border-left: 5px solid #2878ff;
  text-indent: 1em;
  font-weight: bold;
}

// .auth-type{
//   padding: 10px;
//   border: 1px solid #dcdfe6;
//   border-radius: 5px;
//   &.is-checked{
//     border-color: #1890ff;
//   }
// }
.redText {
  ::v-deep {
    .el-textarea__inner {
      color: red;
    }
  }
}
</style>
